import { render, staticRenderFns } from "./ErrorReport.vue?vue&type=template&id=73bf20f4&scoped=true"
import script from "./ErrorReport.vue?vue&type=script&lang=js"
export * from "./ErrorReport.vue?vue&type=script&lang=js"
import style0 from "./ErrorReport.vue?vue&type=style&index=0&id=73bf20f4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf20f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bf20f4')) {
      api.createRecord('73bf20f4', component.options)
    } else {
      api.reload('73bf20f4', component.options)
    }
    module.hot.accept("./ErrorReport.vue?vue&type=template&id=73bf20f4&scoped=true", function () {
      api.rerender('73bf20f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/postScreening/errorReport/ErrorReport.vue"
export default component.exports